import { render, staticRenderFns } from "./DiscountBadge.vue?vue&type=template&id=26047609&scoped=true"
import script from "./DiscountBadge.vue?vue&type=script&lang=js"
export * from "./DiscountBadge.vue?vue&type=script&lang=js"
import style0 from "./DiscountBadge.vue?vue&type=style&index=0&id=26047609&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26047609",
  null
  
)

export default component.exports